import template from './remind-password.jade';
import validation from '../../../scripts/services/validation';

export default () => {
  return {
    require: ['cianAfRemindPassword', 'form'],
    bindToController: {
      onCancel: '&',
      email: '<?',
    },
    link: (scope, element, attrs, ctrls) => {
      ctrls[0].init(ctrls[1]);
    },
    template,
    controller: [
      'apiService',
      'analyticsService',
      'deviceService',
      function (apiService, analyticsService, deviceService) {
        this.isMobile = deviceService.isMobile;

        this.letterSent = false;
        if (!this.email) {
          this.email = '';
        }

        this.removeRemoteError = () => {
          this.remindPasswordForm.email.$setValidity('userNotFound', true);
        };

        this.cancel = () => {
          this.onCancel();
        };

        this.hideForm = () => {
          this.onCancel();
          this.letterSent = false;
        };

        this.init = form => {
          this.validation = validation(form, 'email', {
            required: 'Не заполнен "E-mail"',
            email: 'Некорректный "E-mail"',
            userNotFound: 'Пользователь не найден',
          });
        };

        this.submit = () => {
          this.listeners = false;
          if (this.remindPasswordForm.$invalid) {
            return false;
          }

          apiService
            .restorePassword({
              email: this.email,
            })
            .then(
              response => {
                if (response.data.status === 'ok') {
                  this.letterSent = true;

                  analyticsService.successSubmitForgotPassword();
                }
              },
              () => {
                this.remindPasswordForm.email.$setValidity('userNotFound', false);
                this.remindPasswordForm.email.$render();
              },
            );
        };
      },
    ],
    controllerAs: 'remindPasswordCtrl',
    replace: true,
  };
};
